const AudioCxt = (window as any).AudioContext || (window as any).webkitAudioContext;

let audioContext: AudioContext = new AudioCxt();

audioContext.onstatechange = event => {
  console.log("state changed", (event.target as AudioContext).state);
};

const refreshAudioContext = () => {
  console.log("refreshing audio context");

  audioContext = new AudioContext();
};

export { audioContext, refreshAudioContext };
